export const BlogCategories = [
  'All',
  'Marketing',
  'Cryptocurrency',
  'Motivation',
  'Web Development'
];
